import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../Components/Hero";
import contactData from "../Data/ContactData";
import "../Styles/Contact.css";

const WEB3FORMS_ACCESS_KEY = "5dd7e12e-b551-4164-9ebf-460596c3f568";

function Contact() {
  const location = useLocation();
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: "", message: "" });

    const form = event.currentTarget;
    const formData = new FormData(form);
    formData.set("access_key", WEB3FORMS_ACCESS_KEY);
    formData.set("subject", `PyLoan website question: ${formData.get("subject")}`);
    formData.set("from_name", formData.get("name"));

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.success) {
        form.reset();
        setStatus({
          type: "success",
          message: "Thanks. Your message has been sent and we will reply by email.",
        });
      } else {
        setStatus({
          type: "error",
          message: "We could not send your message. Please try again or email us directly.",
        });
      }
    } catch (error) {
      setStatus({
        type: "error",
        message: "We could not send your message. Please try again or email us directly.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="contact_container">
        <Hero link="Home" pageName="Contact PyLoan" />
      </div>

      <main className="contact_page scontainer">
        <section className="contact_information_notice">
          <h2>General questions only</h2>
          <p>
            PyLoan is an independent information website. We do not accept or
            process loan applications, arrange loans, connect applicants with
            lenders or guarantee approval. Please do not include passwords,
            OTPs, bank login details or full card numbers in your message.
          </p>
        </section>

        <section className="contact_cards row" aria-label="Contact details">
          {contactData.map((item) => (
            <div className="col-xl-4 col-md-4 col-sm-12" key={item.id}>
              <div className="contact_card">
                <div className="contact_card_top">
                  <div className="contact_circle" aria-hidden="true">
                    <i className={item.icon}></i>
                  </div>
                  <div className="title_box">
                    <h4>{item.title}</h4>
                    <p>{item.subTitle}</p>
                  </div>
                </div>
                <div className="contact_card_bottom">
                  <div className="contact_bottom_left">
                    {item.id === 1 ? (
                      <a href="mailto:Mudraloanhelp0@gmail.com">{item.desc1}</a>
                    ) : item.id === 2 ? (
                      <a href="tel:9873691307">{item.desc1}</a>
                    ) : (
                      <p>{item.desc1}</p>
                    )}
                  </div>
                  <div className="circle_white" aria-hidden="true">
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </section>

        <section className="contact_form_container row">
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="contact_map">
              <iframe
                title="PyLoan office location"
                src="https://www.google.com/maps?q=B12%2C%20Mahipalpur%20Bypass%20Road%2C%20Mahipalpur%2C%20New%20Delhi%20110037&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="contact_form_box">
              <p className="exp_super_title">Send a message</p>
              <h2>Ask a general question</h2>
              <p className="contact_form_intro">
                Tell us what you would like to understand about the guides on
                this website. We can point you towards the relevant information
                or official source.
              </p>

              <form className="contact_form" onSubmit={onSubmit}>
                <label htmlFor="contact-name">Your name <span className="required">*</span></label>
                <input id="contact-name" name="name" type="text" autoComplete="name" required />

                <label htmlFor="contact-email">Email address <span className="required">*</span></label>
                <input id="contact-email" name="email" type="email" autoComplete="email" required />

                <label htmlFor="contact-phone">Phone number <span className="required">*</span></label>
                <input id="contact-phone" name="phone" type="tel" autoComplete="tel" inputMode="tel" required />

                <label htmlFor="contact-subject">What is your question about? <span className="required">*</span></label>
                <select id="contact-subject" name="subject" defaultValue="" required>
                  <option value="" disabled>Select a topic</option>
                  <option value="loan-guides">Loan guides</option>
                  <option value="government-schemes">Government schemes</option>
                  <option value="women-entrepreneur-finance">Women entrepreneur finance</option>
                  <option value="website-question">Website or privacy question</option>
                </select>

                <label htmlFor="contact-message">Your message <span className="required">*</span></label>
                <textarea id="contact-message" name="message" rows="5" required></textarea>

                <input type="checkbox" name="botcheck" className="hidden" tabIndex="-1" autoComplete="off" />
                <button className="btn contact_btn" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Send message"}
                </button>
                <p className="contact_form_notice">
                  By submitting, you allow PyLoan to use these details to reply
                  to your question, as described in our privacy policy.
                </p>
                {status.message && (
                  <p className={`val_msg ${status.type}`} role="status">{status.message}</p>
                )}
              </form>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Contact;
